module.exports = __webpack_public_path__ + "img/com.codeway.faceswap.ec7a326b.png";